/**
 * @fileoverview GET handler for the "/engagement/report_dashboards/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { ReportDashboardsTags } from "./constants";
import type { ReportDashboardsTagsParams, ReportDashboardsTagsResult } from "./types";

export const getDashboardReportTags = reactQueryFetcherAdapter(
  ReportDashboardsTags,
  (signal: AbortSignal, { appGroupId }: ReportDashboardsTagsParams): Promise<ReportDashboardsTagsResult> => {
    return fetch(
      "/engagement/report_dashboards/tags",
      "GET",
      {
        show_id: true,
        app_group_id: appGroupId,
      },
      { signal }
    );
  }
);
